/**
 * ScrollSpy utility to update URL hash when scrolling to different sections
 * @returns {Object} ScrollSpy methods
 */
const ScrollSpy = () => {
    // Store all sections that should be tracked
    let sections = [];
    // List of allowed section IDs
    const allowedSectionIds = ['servicos', 'contacto', 'portfolio', 'faq'];
    // Options for the Intersection Observer
    const options = {
        root: null, // viewport
        rootMargin: '0px',
        threshold: 0.5 // trigger when 50% of the section is visible
    };

    /**
     * Update URL hash without scrolling
     * @param {string} hash - The hash to set in the URL
     */
    const updateUrlHash = (hash) => {
        if (history.pushState) {
            history.pushState(null, null, hash);
        } else {
            // Fallback for older browsers
            window.location.hash = hash;
        }
    };

    /**
     * Callback for Intersection Observer
     * @param {Array} entries - Intersection entries
     */
    const handleIntersect = (entries) => {
        entries.forEach(entry => {
            // If the section is intersecting (visible)
            if (entry.isIntersecting) {
                const id = entry.target.getAttribute('id');
                // Only update URL if the ID is in our allowed list
                if (id && allowedSectionIds.includes(id)) {
                    updateUrlHash(`#${id}`);
                }
            }
        });
    };

    /**
     * Initialize the ScrollSpy
     * @param {string} sectionSelector - CSS selector for sections to track
     */
    const init = (sectionSelector = '[id]') => {
        // Create a new Intersection Observer
        const observer = new IntersectionObserver(handleIntersect, options);

        // Get all sections with IDs
        sections = document.querySelectorAll(sectionSelector);

        // Observe each section
        sections.forEach(section => {
            const id = section.getAttribute('id');
            // Only observe sections with allowed IDs
            if (id && allowedSectionIds.includes(id)) {
                observer.observe(section);
            }
        });
    };

    return {
        init
    };
};

export default ScrollSpy;
